var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDogecoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-dogecoin"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dogecoin",
    clipPath: "url(#clip-dogecoin)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51",
    transform: "translate(-2.654 -2.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(2.654 2.654)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 30,
    height: 30,
    rx: 7,
    fill: "#ddb200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,7A7,7,0,0,1,7,0h6.5a16.354,16.354,0,0,1,.815,5.114A16.367,16.367,0,0,1,0,21.351Z",
    transform: "translate(0 0)",
    fill: "#ebbf00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M145.416,150.331a1.019,1.019,0,0,1-1.01-1.344.991.991,0,0,1,.96-.675c.576-.006,1.152-.013,1.727,0,.225.006.276-.063.275-.28-.009-1.811,0-3.621-.011-5.432,0-.252.055-.333.322-.33,1.214.013,2.427,0,3.641,0a6.993,6.993,0,0,1,5.1,2.209,6.674,6.674,0,0,1,1.645,6.988,6.8,6.8,0,0,1-5.449,4.767,6.207,6.207,0,0,1-1.246.117c-1.235,0-2.47-.009-3.7.006-.252,0-.306-.076-.3-.316.009-1.81,0-3.62.01-5.428,0-.228-.046-.308-.289-.3C146.526,150.338,145.971,150.331,145.416,150.331Zm3.968-3.969c0,.575,0,1.151-.015,1.725,0,.18.054.23.23.227.565-.01,1.13-.005,1.695,0a1.009,1.009,0,1,1,.006,2.011h-1.695c-.108,0-.235-.039-.235.154q.006,1.85,0,3.7c0,.121.043.167.164.163a15.5,15.5,0,0,0,2.877-.126,5.174,5.174,0,0,0,3.921-4.078,5.017,5.017,0,0,0-2.252-5.055,5.586,5.586,0,0,0-3.517-.779c-.333,0-.666,0-1-.013-.152-.006-.2.05-.194.2.01.624.01,1.25.014,1.875Z",
    transform: "translate(-133.907 -131.83)",
    fill: "#f0f1f0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogecoin);
export default __webpack_public_path__ + "static/media/dogecoin.4239eb9494876c477a9f37e16b1a5a05.svg";
export { ForwardRef as ReactComponent };